import React from 'react';
import { TextInput } from 'telstra-ui/components/text-input/TextInput';
import { Dropdown } from 'telstra-ui/components/drop-down/Dropdown';
import SummaryDetails from '../../../ssm-homepage/ssm-components/summary-details/summary-details';
import { prepareDropDownOptionsArry } from '../../adaptive-mobility-external.actions';

const InterestInputFields = (props) => {
  const {
    authorableContent: {
      interestSection: {
        description,
        allRequiredText,
        subHeadingText,
      },
      firstName,
      lastName,
      email,
      phone,
      company,
      job,
      seniority,
      industry,
      country,
      companySize,
      preferredContactTime,
    },
    interestInputFieldsValue,
    validateInputFields,
    onChangeInputFields,
    onBlurInputFields,
    onChangeDropDown,
    onBlurDropDown,
  } = props;

  return (
    <div className="interest-fields-section">
      <SummaryDetails
        summaryTitle={subHeadingText}
        summaryText={description}
        customHeadingClass="heading34"
      />
      <div className="row">
        <div className="col-12 all-required">{allRequiredText}</div>
      </div>
      <div className="row">
        <div className="col-md-6">
          <TextInput
            name="firstName"
            id="firstName"
            className="input-fields"
            label={firstName.label}
            value={interestInputFieldsValue.firstName}
            onChange={onChangeInputFields}
            onBlur={onBlurInputFields}
            errors={(validateInputFields.firstName) ? [firstName.errorText] : ''}
          />
        </div>
        <div className="col-md-6">
          <TextInput
            name="lastName"
            id="lastName"
            className="input-fields"
            label={lastName.label}
            value={interestInputFieldsValue.lastName}
            onChange={onChangeInputFields}
            onBlur={onBlurInputFields}
            errors={(validateInputFields.lastName) ? [lastName.errorText] : ''}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-6">
          <TextInput
            name="email"
            id="email"
            className="input-fields"
            label={email.label}
            value={interestInputFieldsValue.email}
            onChange={onChangeInputFields}
            onBlur={onBlurInputFields}
            errors={(validateInputFields.email) ? [email.errorText] : ''}
          />
        </div>
        <div className="col-md-6">
          <TextInput
            name="phone"
            id="phone"
            className="input-fields"
            label={phone.label}
            onChange={onChangeInputFields}
            value={interestInputFieldsValue.phone}
            onBlur={onBlurInputFields}
            errors={(validateInputFields.phone) ? [phone.errorText] : ''}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          <TextInput
            name="company"
            id="company"
            className="input-fields"
            label={company.label}
            value={interestInputFieldsValue.company}
            onChange={onChangeInputFields}
            onBlur={onBlurInputFields}
            errors={(validateInputFields.company) ? [company.errorText] : ''}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-6">
          <Dropdown
            dropdownId="job"
            className="job"
            label={job.label}
            value={interestInputFieldsValue.job}
            options={prepareDropDownOptionsArry(job.options)}
            onOptionClick={onChangeDropDown}
            highlightSelected
            onBlur={onBlurDropDown}
            errors={(validateInputFields.job) ? [job.errorText] : ''}
          />
        </div>
        <div className="col-md-6">
          <Dropdown
            dropdownId="seniority"
            className="seniority"
            label={seniority.label}
            value={interestInputFieldsValue.seniority}
            options={prepareDropDownOptionsArry(seniority.options)}
            onOptionClick={onChangeDropDown}
            highlightSelected
            onBlur={onBlurDropDown}
            errors={(validateInputFields.seniority) ? [seniority.errorText] : ''}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-6 col-sm-12">
          <Dropdown
            dropdownId="industry"
            className="industry"
            label={industry.label}
            value={interestInputFieldsValue.industry}
            options={prepareDropDownOptionsArry(industry.options)}
            onOptionClick={onChangeDropDown}
            highlightSelected
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-6  col-sm-12">
          <Dropdown
            dropdownId="country"
            className="country"
            label={country.label}
            value={interestInputFieldsValue.country}
            options={prepareDropDownOptionsArry(country.options)}
            onOptionClick={onChangeDropDown}
            highlightSelected
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-6 col-sm-12">
          <Dropdown
            dropdownId="companySize"
            className="companySize"
            label={companySize.label}
            value={interestInputFieldsValue.companySize}
            options={prepareDropDownOptionsArry(companySize.options)}
            onOptionClick={onChangeDropDown}
            highlightSelected
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-6 col-sm-12">
          <Dropdown
            dropdownId="preferredContactTime"
            className="preferredContactTime"
            label={preferredContactTime.label}
            value={interestInputFieldsValue.preferredContactTime}
            options={prepareDropDownOptionsArry(preferredContactTime.options)}
            onOptionClick={onChangeDropDown}
            highlightSelected
          />
        </div>
      </div>
    </div>
  );
};

export default InterestInputFields;
